import React from "react";
import { Typography } from "@material-ui/core";

import { FieldArrayFieldProps } from "../../../../../forms/fields/field-array/field-array-field.props";
import { TextField } from "../../../../../forms/fields/text-field/text-field.component";

import { useSizeFieldsStyles } from "./size-fields.styles";

export const SizeFields = (props: FieldArrayFieldProps) => {
  const classes = useSizeFieldsStyles();

  const desktopName = `${props.name}.${props.index}.desktopDimensions`;
  const mobileName = `${props.name}.${props.index}.mobileDimensions`;
  const tabletName = `${props.name}.${props.index}.tabletDimensions`;

  return (
    <div className={classes.fieldWrapper}>
      <Typography variant={"h5"}>{props.field.assetType}</Typography>

      <label className={classes.label}>
        <div>Desktop (px):</div>
        <TextField
          disabled={props.disabled}
          form={props.form}
          name={desktopName}
          size="small"
          variant="standard"
          userPermissions={props.userPermissions}
        />
      </label>

      <label className={classes.label}>
        <div>Tablet (px):</div>
        <TextField
          disabled={props.disabled}
          form={props.form}
          name={tabletName}
          size="small"
          variant="standard"
          userPermissions={props.userPermissions}
        />
      </label>

      <label className={classes.label}>
        <div>Mobile (px):</div>
        <TextField
          disabled={props.disabled}
          form={props.form}
          name={mobileName}
          size="small"
          variant="standard"
          userPermissions={props.userPermissions}
        />
      </label>
    </div>
  );
};
